import { Component, input } from '@angular/core';
import { BreadcrumbItems } from '@app/models/breadcrumb.model';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-workbench-breadcrumb',
  templateUrl: './workbench-breadcrumb.component.html',
  styleUrls: ['./workbench-breadcrumb.component.scss'],
  imports: [RouterLink]
})

export class WorkbenchBreadcrumbComponent {
  title = input<string>('');
  subtitle = input<string>('');
  upperSubtitle = input<string>('');
  breadcrumbItems = input<BreadcrumbItems[]>([]);

  constructor() {}
}
